import * as ACTION_TYPES from 'Redux/modules/auth/types';
// import { UI_CLEAR_TOAST, UI_SHOW_TOAST } from 'Redux/modules/ui/types';

import apiClients, { initClient } from './clientFactory';

function clientMiddleware(clients) {
  return ({ dispatch, getState }) =>
    next =>
    action => {
      if (!action) return;
      if (typeof action === 'function') {
        return action(dispatch, getState);
      }

      const { promise, types, options, ...rest } = action;

      if (!promise || !options) {
        return next(action);
      }

      const { clientName, headers, apiUrl } = options;
      const client = headers && apiUrl ? initClient(apiUrl) : clients[clientName];

      const { token } = getState().auth.data;
      client.setJwtToken(token);

      const [REQUEST, SUCCESS, FAILURE] = types;
      next({ ...rest, type: REQUEST });

      const actionPromise = promise(client, dispatch);

      actionPromise
        .then(
          result => next({ ...rest, payload: result, type: SUCCESS }),
          error => {
            if (error.data?.id === 'SESSION_REVOKED')
              return next({ type: ACTION_TYPES.AUTH_LOGOUT });
            // dispatch({
            //   type: UI_SHOW_TOAST,
            //   payload: {
            //     message: error?.message ?? error?.data?.message ?? 'Some thing when wrong!',
            //     type: 'error',
            //   },
            // });
            // setTimeout(() => {
            //   dispatch({ type: UI_CLEAR_TOAST });
            // }, 5000);
            return next({ ...rest, error, type: FAILURE });
          },
        )
        .catch(error => {
          console.error(error);
          next({ ...rest, error, type: FAILURE });
        });

      return actionPromise;
    };
}

export default clientMiddleware(apiClients);
